// import MaterialTable from 'material-table'
import React, { useEffect } from 'react'
import Service from '../Networking/NetworkingUtils'
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from "notistack";
import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';


var token = getCookie("bb_metaverse_token");


const ProjectAssets = (props) => {


  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState([])
  const { enqueueSnackbar } = useSnackbar();
  const [columns] = React.useState([
    { title: 'Name', field: 'asset_name' },
    { title: 'Asset Source', field: 'asset_source' },
    { title: 'File Name', field: 'asset_parameter', render: rowData => rowData.open_file }
  ])

  const getData = () => {
    Service.get(`/api/projects/asset/get_project_assets/?project=${props.row.id}`, {
      headers: {
        Authorization: "Token " + token,
      },
    }).then(res => {
      setData(res.data)
      setLoading(false)

    }).catch(error => {
      console.log(error);
      enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      })
    })
  }

  useEffect(() => {
    setLoading(true)
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <div>
      {loading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'><CircularProgress /></Box> :
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                {columns && columns.map((column) => (
                  <TableCell key={column.field}>{column.title}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.map((row) => (
                <React.Fragment key={row.id}>
                  <TableRow sx={{ cursor: 'pointer' }}>
                    {columns && columns.map((column) => (
                      <TableCell key={column.field}  >
                        {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>}
    </div>
  )
}

export default ProjectAssets